import { render, staticRenderFns } from "./notAccess.vue?vue&type=template&id=4ac8d389&scoped=true"
import script from "./notAccess.vue?vue&type=script&lang=js"
export * from "./notAccess.vue?vue&type=script&lang=js"
import style0 from "./notAccess.vue?vue&type=style&index=0&id=4ac8d389&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8d389",
  null
  
)

export default component.exports